import * as React from "react";

export const SvgSearch = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#a)">
			<path
				d="M18.78 17.72 13.661 12.6a7.09 7.09 0 0 0 1.589-4.476C15.25 4.197 12.053 1 8.125 1 4.196 1 1 4.196 1 8.125c0 3.928 3.197 7.125 7.125 7.125a7.09 7.09 0 0 0 4.476-1.588l5.119 5.118a.748.748 0 0 0 1.06 0 .749.749 0 0 0 0-1.06ZM8.125 13.75A5.63 5.63 0 0 1 2.5 8.125 5.63 5.63 0 0 1 8.125 2.5a5.63 5.63 0 0 1 5.625 5.625 5.63 5.63 0 0 1-5.625 5.625Z"
				fill={props.color ?? "#A8A8A8"}
				stroke={props.color ?? "#A8A8A8"}
				strokeWidth={0.3}
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h20v20H0z" />
			</clipPath>
		</defs>
	</svg>
);
